import * as React from 'react';
import { View } from 'react-native';

export default function BarcodeScannerModal(props: { isVisible: boolean, onClose: any, onBarCodeRead: any }) {
    return (<View />);
}